import React from 'react';
import Icon from '@/app/components/Icon';
import { paymentPartner } from '../footerMenuList';
import TextSmall from '../../Typography/TextSmall';

function FooterPaymentMethod() {
  return (
    <div className="min-w-[241px] max-w-[12.55%]">
      <TextSmall
        text="Payment Methods"
        className="text-white text-sm lg:text-sm font-bold mb-12 whitespace-nowrap"
      />

      <div className="xs:w-full lg:w-[230px] p-5 space-y-[5px]">
        <div className="flex justify-center items-center gap-[3px] p-5 rounded-xl bg-white">
          <Icon type="cash-gradient" />
          <TextSmall
            text="Cash On Delivery"
            className="text-senate text-sm lg:text-sm font-semibold"
          />
        </div>
        <div className="flex justify-center items-center gap-[3px] py-5 rounded-xl bg-white">
          <Icon type="calendar-gradient" />
          <TextSmall
            text="Easy monthly installments"
            className="text-senate text-sm lg:text-sm font-semibold whitespace-nowrap"
          />
        </div>
        <div className="grid grid-cols-3 gap-[5px]">
          {paymentPartner?.map((item, index) => (
            <div
              key={item?.id ?? index}
              className="bg-white w-full max-w-[73px] h-[40px] flex justify-center items-center rounded-xl px-4 py-5"
            >
              <Icon type={item?.iconType} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FooterPaymentMethod;
